import React, {Component} from 'react';
import './App.css';

export default class Bio extends React.Component {

    render() {
        return (
        <div>
            <code className = "bio">Hi! My name is Peter Koncelik, and I am currently a Junior at Vanderbilt University
                studying Computer Science, Applied Mathematics, and Classics. I most recently worked as a Software
                Engineer Intern at Capital One. I currently work in a NASA-partnered lab researching 
                high-performance computing in the presence of outer-space radiation effects. I have also worked as a TA in 
                the Computer Science and Mathematics departments at Vanderbilt University.
            </code> 
            <code className = "bio">    
                I have experience in software engineering across the full stack, and am especially excited by backend development, artificial intelligence,
                cloud computing, and algorithm theory. Look below to see some of my work, interests, projects, and contact information. 
            </code>
        </div>
        );
    }
}